import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { PoligonPoligonDetail } from 'app/models/poligon-poligonDetail.model';
import { Poligon, PoligonDetail } from 'app/models/poligon.model';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class PoligonService {

    poligon: any[];
    onChanged: BehaviorSubject<any>;

    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
    ) {
        this.onChanged = new BehaviorSubject({});
    }


    add(entity: Poligon): Promise<Poligon> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "poligons/add", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    update(entity: Poligon): Promise<Poligon> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "poligons/update", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    delete(entity: Poligon): Promise<Poligon> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "poligons/delete", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    addDetail(entity: PoligonDetail): Promise<PoligonDetail> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "poligons/addDetail", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    getPoligons(companyId: number): Promise<Array<Poligon>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "poligons/" + companyId)
                .subscribe((response: any) => {
                    this.poligon = response;
                    this.onChanged.next(this.poligon)
                    resolve(response);
                }, reject);
        });
    }

    getPoligonContainerDetail(companyId: number): Promise<Array<PoligonPoligonDetail>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "poligons/GetContainerDetail/" + companyId)
                .subscribe((response: any) => {
                    this.poligon = response;
                    this.onChanged.next(this.poligon)
                    resolve(response);
                }, reject);
        });
    }
    
    getByPoligonDetail(discriminator_Id: number): Promise<Array<PoligonDetail>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "poligons/GetbyPoligonDetail/" + discriminator_Id)
                .subscribe((response: any) => {
                    this.poligon = response;
                    this.onChanged.next(this.poligon)
                    resolve(response);
                }, reject);
        });
    }

    getByPoligon(poligonId: number): Promise<Poligon> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "poligons/getbypolygon?id=" + poligonId)
                .subscribe((response: any) => {
                    this.poligon = response;
                    this.onChanged.next(this.poligon)
                    resolve(response);
                }, reject);
        });
    }
    getPoligonDetail(poligonId: number): Promise<Array<PoligonDetail>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "poligons/GetbyDetail/" + poligonId)
                .subscribe((response: any) => {
                    this.poligon = response;
                    this.onChanged.next(this.poligon)
                    resolve(response);
                }, reject);
        });
    }

    deletePoligonDetail(pd: PoligonDetail): Promise<PoligonDetail> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "poligons/deletePoligonDetail", pd)
                .subscribe((response: any) => {
                    this.poligon = response;
                    this.onChanged.next(this.poligon)
                    resolve(response);
                }, reject);
        });
    }

    removeRange(pd: Array<PoligonDetail>): Promise<Array<PoligonDetail>> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "poligons/removeRange", pd)
                .subscribe((response: any) => {
                    this.poligon = response;
                    this.onChanged.next(this.poligon)
                    resolve(response);
                }, reject);
        });
    }
}
